import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { Logo } from "./Logo";
import { scrollToId } from "./SmoothScroll";
import { useLang } from "../../i18n/LangContext";
import { useSite } from "../../lib/SiteContext";

const LINKS = ["services", "calculator", "solutions", "impact", "why"];

export const LangToggle = () => {
  const { lang, setLang } = useLang();
  return (
    <div className="flex rounded-full border border-white/15 p-0.5 text-xs font-semibold" data-testid="lang-toggle">
      {["en", "hi"].map((l) => (
        <button
          key={l}
          data-testid={`lang-${l}-btn`}
          onClick={() => setLang(l)}
          className={`rounded-full px-3 py-1.5 transition-colors duration-300 ${lang === l ? "bg-white text-ink" : "text-slate-300 hover:text-white"}`}
        >
          {l === "en" ? "EN" : "हिं"}
        </button>
      ))}
    </div>
  );
};

export const Navbar = () => {
  const { t, lang } = useLang();
  const { settings } = useSite();
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const on = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", on);
    return () => window.removeEventListener("scroll", on);
  }, []);
  const go = (id) => {
    setOpen(false);
    scrollToId(id);
  };
  const ann = settings.announcement_on ? settings[`announcement_${lang}`] : "";

  return (
    <header className="fixed inset-x-0 top-0 z-50" data-testid="navbar">
      {ann && (
        <div className="bg-saffron px-4 py-2 text-center text-xs font-semibold text-ink sm:text-sm" data-testid="announcement-bar">
          {ann}
        </div>
      )}
      <div className={`transition-[background-color,border-color] duration-500 ${scrolled || open ? "border-b border-white/10 bg-ink/80 backdrop-blur-xl" : "border-b border-transparent"}`}>
        <nav className="mx-auto flex h-16 max-w-7xl items-center justify-between px-5 lg:px-8">
          <button onClick={() => go("top")} data-testid="nav-logo-btn"><Logo /></button>
          <div className="hidden items-center gap-8 lg:flex">
            {LINKS.map((l) => (
              <button key={l} onClick={() => go(l)} data-testid={`nav-${l}-link`} className="nav-link text-sm text-slate-300 hover:text-white">
                {t.nav[l]}
              </button>
            ))}
          </div>
          <div className="flex items-center gap-3">
            <LangToggle />
            <button onClick={() => go("join")} data-testid="nav-join-btn" className="btn-primary hidden sm:inline-flex">
              {t.nav.join}
            </button>
            <button className="text-white lg:hidden" onClick={() => setOpen(!open)} data-testid="mobile-menu-btn" aria-label="Menu">
              {open ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </nav>
        {open && (
          <div className="border-t border-white/10 px-5 pb-6 pt-2 lg:hidden" data-testid="mobile-menu">
            {[...LINKS, "join"].map((l) => (
              <button key={l} onClick={() => go(l)} data-testid={`mobile-nav-${l}-link`} className="block w-full border-b border-white/5 py-4 text-left font-display text-2xl text-white">
                {t.nav[l]}
              </button>
            ))}
          </div>
        )}
      </div>
    </header>
  );
};
